import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import TermsAndCondition from './TermsAndCondition';
import { appSettings } from '../settings';
import { useTranslation } from 'react-i18next';
import { EEnvironments } from '../data/Constants';

import type { IBuildVersion } from '../../types/IComponentTypes';

export const Footer = () => {
  const { t } = useTranslation();

  const color: { [index: string]: string } = {
    DEV: 'bg-yellow',
    TEST: 'bg-orange',
    ACC: 'bg-green',
    Prod: 'bg-gray',
  };

  const [value, setValue] = useState<IBuildVersion>();

  const getVersion = () => {
    return fetch('/versioninfo.json', { cache: 'no-store' }).then((response) => response.json());
  };

  useEffect(() => {
    getVersion().then((data) => {
      setValue(data);
    });
  }, []);

  if (appSettings.Environment === EEnvironments.PROD) {
    return null;
  }

  return (
    <Grid className={`footer root ${color[appSettings.Environment]}`}>
      <Grid className="env">
        <span>
          {t('footer.env')}: {appSettings.Environment}
        </span>
      </Grid>
      <Grid className="termsAndConditionStyle">
        <TermsAndCondition />
        &nbsp;&nbsp;
        <span>
          <b>{t('footer.release')}</b>:{value?.release} | <b>{t('footer.sprint')}</b>:
          {value?.sprint} | <b>{t('footer.build')}</b>:{value?.build} | <b>{t('footer.branch')}</b>:
          {value?.branch} | <b>{t('footer.date')}</b>: {value?.date}
        </span>
      </Grid>
    </Grid>
  );
};
